'use strict';

export default class MainService {

    /*@ngInject*/
    constructor($http, UTIL_URL){
        Object.assign(this, {$http, UTIL_URL});
    }
    
    getUtilData(){
        return this.$http.get(this.UTIL_URL);
    }

}


// WEBPACK FOOTER //
// ./client/app/main-route/main-route.service.js